export const RailEuropeTrueFalseMApping = {
  "": "-----",
  true: "Yes",
  false: "No",
};
